import React from 'react';
import { Input, Typography, Tag } from 'antd';
import { SkuMigrationRow } from '../types';

const { Text } = Typography;

interface Props {
  row:              SkuMigrationRow;
  error?:           string;
  updateTargetName: (sourceSkuId: number, name: string) => void;
}

const MigrationRow: React.FC<Props> = ({ row, error, updateTargetName }) => {
  const model = (row.sourceBuyingModel || '').toUpperCase();
  const tagColor = model === 'EA' ? 'blue' : model === 'ALC' ? 'orange' : 'default';
  const isUnchanged = row.targetSkuName.trim().toLowerCase() === row.sourceSkuName.toLowerCase();

  return (
    <div
      style={{
        display:       'flex',
        alignItems:    'center',
        gap:           12,
        padding:       '8px 0',
        borderBottom:  '1px solid #f0f0f0',
      }}
    >
      {/* Source */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Text type="secondary" style={{ fontSize: 11 }}>SOURCE</Text>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
          {model && <Tag color={tagColor}>{model}</Tag>}
          <Text ellipsis style={{ maxWidth: 260 }}>{row.sourceSkuName}</Text>
        </div>
      </div>

      {/* Arrow */}
      <Text type="secondary" style={{ fontSize: 18, lineHeight: 1 }}>→</Text>

      {/* Target */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Text type="secondary" style={{ fontSize: 11 }}>TARGET NAME</Text>
        <Input
          value={row.targetSkuName}
          onChange={(e) => updateTargetName(row.sourceSkuId, e.target.value)}
          placeholder="Enter new SKU name…"
          status={error ? 'error' : isUnchanged ? 'warning' : undefined}
          style={{ marginTop: 2 }}
          data-testid={`target-name-input-${row.sourceSkuId}`}
        />
        {isUnchanged && !error && (
          <Text type="warning" style={{ fontSize: 12 }}>
            Name must be different from the source
          </Text>
        )}
        {error && (
          <Text type="danger" style={{ fontSize: 12 }}>
            {error}
          </Text>
        )}
      </div>
    </div>
  );
};

export default MigrationRow;
